// Questions deliberately kept OFF the cpq2 UI even though NetSuite still defines
// them and gives them no hide rule.
//
// UI-ONLY: the question/answer data is untouched, so this stays a faithful port and
// a value loaded from an existing item still round-trips on save (see useItemLoader
// + SaveSubmitButton). Re-showing one is deleting its code from that product's
// profile.
//
// The codes themselves now live in src/products/<slug>.ts, because a question CODE
// is only unique WITHIN a configurator: "CORE_TYPE" is hidden in Natural Draft
// Burners and a real, answerable field in Flame Cells. This module is the shared
// accessor both consumers read -- Group.tsx (stop rendering it) and validation.ts
// (stop requiring it). Listing a hidden question in only one of those gives a Save
// and Submit that blocks on a field nobody can see, with no way to clear it.
import { getProfile } from "../products";

/** Is this question manually hidden in the given configurator? */
export function isManuallyHidden(product: string, code: string): boolean {
  return getProfile(product).hiddenQuestionCodes.has(code);
}

/** The manually hidden codes for one configurator (empty when it hides none). */
export function manuallyHiddenCodes(product: string): ReadonlySet<string> {
  return getProfile(product).hiddenQuestionCodes;
}
